import { Box, Chip } from '@mui/material';

import { BASIC_USER, roleToRoleInfo, rolesToDisplay, TEAM_OWNER } from './utils/roles';

export default function RoleChips({ roles }: { roles: string[] }): JSX.Element {
  const shown = rolesToDisplay(roles);

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {shown.length === 0 ? (
        <Chip label={roleToRoleInfo[BASIC_USER].name} size="small" variant="outlined" />
      ) : (
        shown.map((role) => (
          <Chip
            key={role}
            label={roleToRoleInfo[role].name}
            size="small"
            color={role === TEAM_OWNER ? 'primary' : 'default'}
          />
        ))
      )}
    </Box>
  );
}
